import createVueApp from '@phoenix/createVueApp';
import ChapterModal from '@maison/components/inTheMaking/ChapterModal.vue';

document.querySelectorAll('.phoenix-chapter-modal').forEach((el) => {
  const app = createVueApp({}, true);
  app.component('ChapterModal', ChapterModal);
  app.mount(el);
});
